<h2 mat-dialog-title>PHP Settings</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="PHP Version"
      formControlName="phpVersion"
      type="select"
      [options]="phpOptions"
    ></app-input-field>

    <app-input-field
      label="Select modules to enable"
      formControlName="modules"
      type="chips-autocomplete"
      [options]="moduleOptions"
    ></app-input-field>

    <div formArrayName="configs" class="configs">
      @for (config of configs.controls; track $index; let i = $index) {
        <div [formGroupName]="i">
          <app-input-field
            [label]="getConfigName(config.value.parameter)"
            formControlName="value"
            [type]="config.value.parameter === 3 ? 'chips-autocomplete' : 'text'"
            [errorMessages]="ERROR_MESSAGES"
          ></app-input-field>
        </div>
      }
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">Save Changes</button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
